
export const validatePhoneNumber = (number: string) => {
  // Basic validation for international phone numbers
  // Must start with + followed by country code and at least 6 digits
  const phoneRegex = /^\+[1-9]\d{1,14}$/;
  return phoneRegex.test(number);
};
